import * as React from 'react';

import { InjectedRouter } from 'react-router';

import { withRouter } from 'app/context/Router';
import Box from 'components/Box';
import BoxBody from 'components/BoxBody';
import BoxFooter from 'components/BoxFooter';
import Container from 'components/Container';
import TitleHeader from 'components/TitleHeader';
import TosText from 'components/TosText';
// @ts-ignore
import View from 'components/View';
import EventTracking from 'lib/EventTracking';
// @ts-ignore
import PasswordForm from 'user/components/PasswordForm';

type Props = {
  router: InjectedRouter;
};

class SetupPassword extends React.Component<Props> {
  handleSave = () => {
    this.props.router.push('/classes');
    EventTracking.trackKey('tos_and_pp.view');
  };

  render() {
    return (
      <View center>
        <Container size="large">
          <TitleHeader
            title="Remind is a two-way messaging app built for schools"
            subtext="Easily connect with students, parents, and teachers and reach them where they
              are. Send photos or make voice calls all without exposing personal contact information.
              Create an account below to get started."
            size="large"
          />
        </Container>
        <Box
          title="Create a password"
          subtext="Passwords need to be at least six characters long."
          size="small">
          <BoxBody>
            <PasswordForm onSave={this.handleSave} />
          </BoxBody>
          <BoxFooter>
            <TosText />
          </BoxFooter>
        </Box>
      </View>
    );
  }
}

export { SetupPassword };
export default withRouter(SetupPassword);
